/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  OneClickCloseDataInput,
  OneClickOpenDataInput,
  OneClickTradingExecuteStatus,
} from '../models/index';

export interface GetTradingExecuteStatusRequest {
    inputHash: string;
}

export interface SendClosePositionRequest {
    blockchain: SendClosePositionBlockchainEnum;
    oneClickCloseDataInput: OneClickCloseDataInput;
}

export interface SendClosePositionV2Request {
    blockchain: SendClosePositionV2BlockchainEnum;
    oneClickCloseDataInput: OneClickCloseDataInput;
}

export interface SendOpenPositionRequest {
    blockchain: SendOpenPositionBlockchainEnum;
    oneClickOpenDataInput: OneClickOpenDataInput;
}

export interface SendOpenPositionV2Request {
    blockchain: SendOpenPositionV2BlockchainEnum;
    oneClickOpenDataInput: OneClickOpenDataInput;
}

/**
 * 
 */
export class TradingControllerApi extends runtime.BaseAPI {

    /**
     */
    async getPoolSize1Raw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/trading/poolSize`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getPoolSize1(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.getPoolSize1Raw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getTradingExecuteStatusRaw(requestParameters: GetTradingExecuteStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OneClickTradingExecuteStatus>> {
        if (requestParameters['inputHash'] == null) {
            throw new runtime.RequiredError(
                'inputHash',
                'Required parameter "inputHash" was null or undefined when calling getTradingExecuteStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/trading/{input_hash}/status`.replace(`{${"input_hash"}}`, encodeURIComponent(String(requestParameters['inputHash']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getTradingExecuteStatus(requestParameters: GetTradingExecuteStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OneClickTradingExecuteStatus> {
        const response = await this.getTradingExecuteStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async sendClosePositionRaw(requestParameters: SendClosePositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['blockchain'] == null) {
            throw new runtime.RequiredError(
                'blockchain',
                'Required parameter "blockchain" was null or undefined when calling sendClosePosition().'
            );
        }

        if (requestParameters['oneClickCloseDataInput'] == null) {
            throw new runtime.RequiredError(
                'oneClickCloseDataInput',
                'Required parameter "oneClickCloseDataInput" was null or undefined when calling sendClosePosition().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['blockchain'] != null) {
            queryParameters['blockchain'] = requestParameters['blockchain'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/trading/send-close-position`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['oneClickCloseDataInput'],
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async sendClosePosition(requestParameters: SendClosePositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.sendClosePositionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async sendClosePositionV2Raw(requestParameters: SendClosePositionV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['blockchain'] == null) {
            throw new runtime.RequiredError(
                'blockchain',
                'Required parameter "blockchain" was null or undefined when calling sendClosePositionV2().'
            );
        }

        if (requestParameters['oneClickCloseDataInput'] == null) {
            throw new runtime.RequiredError(
                'oneClickCloseDataInput',
                'Required parameter "oneClickCloseDataInput" was null or undefined when calling sendClosePositionV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['blockchain'] != null) {
            queryParameters['blockchain'] = requestParameters['blockchain'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/trading/send-close-position-v2`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['oneClickCloseDataInput'],
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async sendClosePositionV2(requestParameters: SendClosePositionV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.sendClosePositionV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async sendOpenPositionRaw(requestParameters: SendOpenPositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['blockchain'] == null) {
            throw new runtime.RequiredError(
                'blockchain',
                'Required parameter "blockchain" was null or undefined when calling sendOpenPosition().'
            );
        }

        if (requestParameters['oneClickOpenDataInput'] == null) {
            throw new runtime.RequiredError(
                'oneClickOpenDataInput',
                'Required parameter "oneClickOpenDataInput" was null or undefined when calling sendOpenPosition().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['blockchain'] != null) {
            queryParameters['blockchain'] = requestParameters['blockchain'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/trading/send-open-position`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['oneClickOpenDataInput'],
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async sendOpenPosition(requestParameters: SendOpenPositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.sendOpenPositionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async sendOpenPositionV2Raw(requestParameters: SendOpenPositionV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['blockchain'] == null) {
            throw new runtime.RequiredError(
                'blockchain',
                'Required parameter "blockchain" was null or undefined when calling sendOpenPositionV2().'
            );
        }

        if (requestParameters['oneClickOpenDataInput'] == null) {
            throw new runtime.RequiredError(
                'oneClickOpenDataInput',
                'Required parameter "oneClickOpenDataInput" was null or undefined when calling sendOpenPositionV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['blockchain'] != null) {
            queryParameters['blockchain'] = requestParameters['blockchain'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/trading/send-open-position-v2`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['oneClickOpenDataInput'],
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async sendOpenPositionV2(requestParameters: SendOpenPositionV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.sendOpenPositionV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum SendClosePositionBlockchainEnum {
    Monad = 'MONAD'
}
/**
  * @export
  * @enum {string}
  */
export enum SendClosePositionV2BlockchainEnum {
    Monad = 'MONAD'
}
/**
  * @export
  * @enum {string}
  */
export enum SendOpenPositionBlockchainEnum {
    Monad = 'MONAD'
}
/**
  * @export
  * @enum {string}
  */
export enum SendOpenPositionV2BlockchainEnum {
    Monad = 'MONAD'
}
